__turbopack_context__.v({
  "full": "styles-module-scss-module__IBoO_G__full",
  "root": "styles-module-scss-module__IBoO_G__root",
});
